<template>
  <div class="space-y-6" v-if="games?.length" v-auto-animate>
    <div v-for="games, date in groupedGames" :key="date" class="grid gap-2">
      <div class="font-bold">{{ useUcFirst(useDate(date).format('dddd D/M')) }}</div>
      <div class="space-y-3" v-auto-animate>
        <div v-for="game in games" :key="game.id" class="border bg-white rounded-md p-3">
          <PartialsGame :game="game" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  games: {
    type: Array,
    default: () => []
  }
})

// Filter games with home and away team
const games = computed(() => props.games?.filter(game => game.home?.slug && game.away?.slug))

// Group games by date
const groupedGames = computed(() => {
  const groups = {}

  games.value?.forEach(game => {
    if (!game.home?.slug || !game.away?.slug) return

    const dateKey = useDate(game.startDate).format('YYYY-MM-DD')

    if (!groups[dateKey]) {
      groups[dateKey] = []
    }

    groups[dateKey].push(game)
  })

  return groups
})
</script>